import  {Poblacion} from './Poblacion'
export class Emplooyee {

  trabajadorId: Int16Array;
  empresaId: Int16Array;
  codtrab: string;
  nif: string;
  apellidos: string;
  nombre: string;
  direccion: string;
  poblacion: string;
  provincia: string;
  cp: string;
  direccion2: string;
  poblacion2: string
  provincia2: string;
  cp2: string;
  notas: string;
  antecedentes: string;
  fnacimiento: Date;
  sexo: string;
  telefono1: number;
  telefono2: number;
  movil: number;
  ss: string;
  seccion: string;
  puesto: string;
  tAttr1: string;
  tAttr2: string;
  tAttr3: string;
  medicoCabecera: string;
  ambulatorioCabecera: string;
  telefonoCabecera: string;
  faxCabecera: string;
  obs: string;
  oficina: string;
  telOficina: string;
  refTrabajador: string;
  gestoria: string;
  telGestoria: string;
  tipoProfesional: string;
  obsDireccion: string;
  oficinaId: string;
  admitirBajas: string;
  visitaUnica: string;
  npoliza: string;
  fpoliza: Date;
  subsidioDiario: string;
  franquicia: Int16Array;
  exclusiones: string;
  profesionDeclarada: string;
  profesionActual: string;
  regimenLaboral: string;
  domicilioProfesional: string;
  telefonoEmpresa: string;
  codigoCias: string;
  inspeccionCias: string;
  fantiguedad: Date;
  cronico: string;
  absentista: string;
  puestoUrgente: string;
  alarmas: string;
  absentismo: Float32Array;
  despidoObjetivo: string;
  tAttr4: string;
  idiomaExtranjero: string;
  ffinContrato: Date;
  tAttr5: string;
  tAttr6: string;
  tAttr7: string;
  tAttr8: string;
  consentimiento: string;
  jornada: string;
  fconsentimiento: Date;
  fentregaCons: Date;
  importacionId: Int16Array;
  aviso: string;
  tipoConsentimiento: string;
  citarBajaNueva: string;
  fconsGrabado: Date;
  deporte: string;
  habilidad: string;
  email: string;
  telCancelado: string;
  telefono4: string;
  tAttr9: string;
  tAttr10: string;
  tAttr11: string;
  tAttr12: string;
  antecedentesHf: string;
  antecedentesNoPatologicos: string;
  bradford: Int16Array;
  eAttr1: string;
  eAttr2: string;
  eAttr3: string;
  eAttr4: string;
  eAttr5: string;
  eAttr6: string;
  eAttr7: string;
  eAttr8: string;
  eAttr9: string;
  eAttr10: string;
  eAttr11: string;
  eAttr12: string;
  age: number;
  antiguedad: string;

  poblacionList : Poblacion ;
  poblacion2List : Poblacion ;

}
